















    import assign from 'lodash/assign';
    import _Swiper from 'swiper/dist/js/swiper.js';
    import { Component, Prop } from 'vue-property-decorator';
    import BaseComponent from './Base';

    const Swiper = window.Swiper || _Swiper;

    export interface ISwiperComponent {
    getOptions(): any;
    setOptions(options: any): void;
    getSlides(): any[];
    slideTo(index: number): void;
    getSlideIndex(): number;
    setSlidesPerView(slidesPerView: number | string): void;
    update(): any;
}

    export interface ISwiper {
    params: { [key: string]: any };
    slides: any[];
    realIndex: number;
    navigation: {
        update(): void;
    };
    pagination: {
        update(): void;
        render(): void;
    };
    slideTo(index: number): void;
    update(): void;
    updateSlides(): void;
    render(): void;
    destroy(): void;
    on(e: string, f: any): void;
}

// as of swiper 4.0.7
// http://idangero.us/swiper/api/#events
    const DEFAULT_EVENTS: string[] = [
    'beforeDestroy',
    'slideChange',
    'slideChangeTransitionStart',
    'slideChangeTransitionEnd',
    'slideNextTransitionStart',
    'slideNextTransitionEnd',
    'slidePrevTransitionStart',
    'slidePrevTransitionEnd',
    'transitionStart',
    'transitionEnd',
    'touchStart',
    'touchMove',
    'touchMoveOpposite',
    'sliderMove',
    'touchEnd',
    'click',
    'tap',
    'doubleTap',
    'imagesReady',
    'progress',
    'reachBeginning',
    'reachEnd',
    'fromEdge',
    'setTranslate',
    'setTransition',
    'resize',
];

    @Component({
    name: 'swiper',
})
export default class VueSwiper extends BaseComponent implements ISwiperComponent {
    @Prop({ type: Object, default: () => ({}) }) protected readonly options: { [key: string]: any };

    protected swiper: ISwiper;
    protected innerOptions: { [key: string]: any } = this.options;
    protected classes: { [key: string]: any } = {
        wrapperClass: 'swiper-wrapper',
    };
    protected navigationDisabled: boolean = false;

    public getOptions(): any {
        return this.innerOptions;
    }

    public setSlidesPerView(slidesPerView: number | string) {
        this.innerOptions.slidesPerView = slidesPerView;
        this.swiper.params.slidesPerView = slidesPerView;
        this.$nextTick(() => {
            this.update();
        });
    }

    public setOptions(options: any): void {
        this.innerOptions = options;
        this.swiper.params = assign({}, this.swiper.params || {}, options || {});
        this.$nextTick(() => {
            this.update();
        });
    }

    public getSlides(): any[] {
        if (!this.swiper) {
            return [];
        }
        return this.swiper.slides;
    }

    public getSlideIndex(): number {
        if (!this.swiper) {
            return 0;
        }
        return this.swiper.realIndex;
    }

    public slideTo(index: number): void {
        if (this.swiper) {
            this.swiper.slideTo(index);
        }
    }

    public update(): void {
        if (this.swiper) {
            this.swiper.update();
            this.swiper.navigation.update();
            this.swiper.pagination.render();
            this.swiper.pagination.update();
        }
    }

    protected ready(): any {
        if (!this.swiper) {
            this.mountInstance();
        }
    }

    protected mounted(): any {
        if (!this.swiper) {
            let setClassName = false;
            for (const className in this.classes) {
                if (this.classes.hasOwnProperty(className)) {
                    if (this.options[className]) {
                        setClassName = true;
                        this.classes[className] = this.options[className];
                    }
                }
            }
            setClassName ? this.$nextTick(this.mountInstance) : this.mountInstance();
        }
    }

    protected activated(): void {
        this.update();
    }

    protected updated(): void {
        // this.update();
    }

    protected beforeDestroy(): void {
        this.$nextTick(() => {
            if (this.swiper) {
                this.swiper.destroy();
                delete this.swiper;
            }
        });
    }

    protected mountInstance(): void {
        this.swiper = new Swiper(this.$el, this.innerOptions);
        this.bindEvents();
        if (this.getSlides().length < 2) {
            this.navigationDisabled = true;
        }
        this.$emit('ready', this.swiper);
    }

    protected bindEvents(): void {
        const vm = this;
        DEFAULT_EVENTS.forEach((eventName) => {
            if (vm.swiper && vm.swiper.on) {
                vm.swiper.on(eventName, (...args) => {
                    vm.$emit(eventName, ...args);
                    vm.$emit(eventName.replace(/([A-Z])/g, '-$1').toLowerCase(), ...args);
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Swiper.vue